import PropTypes, { InferProps } from 'prop-types'
import { HotelSearchFormModalTypes } from '../../constants/Constants'

export default function HotelMultiOccInput ({
  modalType,
  renderTravelerSelection,
  renderRoomSelection
}: InferProps<typeof HotelMultiOccInput.propTypes>) {
  const isInvalidModalType = modalType === HotelSearchFormModalTypes.SOPQ || modalType === HotelSearchFormModalTypes.PRICEBREAKERS
  return (
    !isInvalidModalType
      ? renderTravelerSelection()
      : renderRoomSelection()
  )
}

HotelMultiOccInput.propTypes = {
  modalType: PropTypes.string,
  renderRoomSelection: PropTypes.func.isRequired,
  renderTravelerSelection: PropTypes.func.isRequired
}
